// Utilities
import React from "react";
import { useEffect, useState } from "react";
import { Image as FluentImage, useTheme } from "@fluentui/react";
// Telemetry
import { useLoggers } from "../../../hooks/useLoggers";
import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
/**
 * Renders the lazy image
 */ export function LazyImage({ fetchImage, placeholderSrc, ...rest }) {
    const [src, setSrc] = useState(placeholderSrc);
    const theme = useTheme();
    const { traceLogger } = useLoggers();
    useEffect(()=>{
        const imageSource = async ()=>{
            try {
                const src = await retry(()=>fetchImage(theme, traceLogger));
                if (src !== null) {
                    setSrc(src);
                } else {
                    setSrc(placeholderSrc);
                }
            } catch  {
                traceLogger.logTrace(0x1e2516e0 /* tag_4jr16 */ , TraceLevel.Error, "LazyImage - error loading image");
                setSrc(placeholderSrc);
            }
        };
        imageSource();
    }, [
        fetchImage,
        placeholderSrc,
        theme,
        traceLogger
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ React.createElement(FluentImage, {
        ...rest,
        src: src
    }));
}
